import { authFetch } from './authFetch';
const API_BASE_URL = import.meta.env.VITE_API_URL ?? '';
export async function executeAiJobs(movieId, request) {
    const response = await authFetch(`${API_BASE_URL}/api/movies/${movieId}/ai/execute-jobs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request),
    });
    if (!response.ok) {
        const errorBody = await response.text();
        throw new Error(errorBody || `execute-jobs failed: ${response.status}`);
    }
    return (await response.json());
}
